<template>
  <v-select v-if="render" 
            label="name" 
            :getOptionLabel="getOptionLabel" 
            :filterable="false" 
            :options="componentOptions" 
            v-model="selectedOption" 
            @search="onSearch" 
            :multiple="multiple"
            :placeholder="placeholder">
    <span slot="no-options">{{ noOptionsMessage }}</span>
    <!-- <template slot="option" scope="customer">{{ customer.name }} ({{ customer.erp_id }})</template>
    <template slot="selected-option" scope="customer">{{ customer.name }} ({{ customer.erp_id }})</template> -->
  </v-select>
</template>

<script>
import vSelect from 'vue-select'

export default {
  name: "SearchAndSelect",
  props: {
    placeholder: {
      type: String,
      default: ''
    },
    multiple: {
      type: Boolean,
      default: false
    },
    initialValue: {
      default: null
    },
    minChars: {
      type: Number,
      default: 0
    },
    searchConfig: {
      type: Object,
      required: true
    },
    /**
     * Callback to generate the label text. If {option}
     * is an object, returns option[this.label] by default.
     * @type {Function}
     * @param  {Object || String} option
     * @return {String}
     */
    getOptionLabel: {
      type: Function,
      default: function(option) {
        if (typeof option === 'object') {
          if (!option.hasOwnProperty(this.label)) {
            return console.warn(
              `[vue-select warn]: Label key "option.${this.label}" does not` +
              ` exist in options object ${JSON.stringify(option)}.\n` +
              'http://sagalbot.github.io/vue-select/#ex-labels'
            )
          }
          if (this.label && option[this.label]) {
            return option[this.label]
          }
        }
        return option;
      }
    }
  },

  components:{
    vSelect
  },

  data() {
    return {
      render: false,
      componentOptions: [],
      selectedOption: null,
    }
  },

  created() {
    this.selectedOption = this.initialValue
    this.render = true
  },

  computed: {
    noOptionsMessage() {
      let message = 'Aucun résultat correspondant'
      
      if (this.minChars > 0) {
        message += ` (${this.minChars} caractères minimum)`
      }

      return message
    }
  },

  methods: {
    onSearch(search, loading) {
      if (this.minChars === 0 || search.length >= this.minChars) {
        loading(true)
  
        this.searchFunction(loading, search, this)
      }
    },

    searchFunction: _.debounce((loading, search, vm) => {
      let specificCaseFound = false
      let params = {}

      // Specific cases handling
      if (vm.searchConfig.hasOwnProperty('specific_cases') && Object.keys(vm.searchConfig.specific_cases).length > 0) {
        const specificCases = vm.searchConfig.specific_cases
        
        _.forEach(specificCases, function(element, index) {
          if (!specificCaseFound) {
            let conditionArray = index.split(':')
            let conditionType = conditionArray[0]
            let conditionValue = conditionArray[1]
  
            if ('max' === conditionType) {
              if (search.length < conditionValue) {
                specificCaseFound = true
                params = element.params
                params.search = search
  
                return (vm.axios.get(element.uri, { params })
                  .then((response) => {
                    vm.componentOptions = response.data[element.data_index]
  
                    loading(false)
                  }))
              }
            }
          }
        })
      }
      
      // Default behavior
      if (!specificCaseFound && search.length >= 0) {
        params = vm.searchConfig.default_params
        params.search = search

        return (vm.axios.get(vm.searchConfig.default_uri, { params })
          .then((response) => {
            vm.componentOptions = response.data[vm.searchConfig.default_data_index]

            loading(false)
          }))
      }
    }, 500)
  },

  watch:{
    selectedOption() {
      this.$emit("field-updated", this.selectedOption)
    }
  }
}
</script>

<style lang="scss">
  .v-select {
    font-family: titillium, sans-serif;
    border-radius: 2px;
    border-color:rgba(0, 0, 0, 0.07);

    a {
      opacity: 1 !important;
    }
  }

  .dropdown-menu > .highlight > a {
    /* .v-select .dropdown-menu >
    * required to override bootstrap 3's
    * .dropdown-menu > li > a:hover {} styles
    */
    background:#e7e7e7!important;
    color: #333!important;
  }

  div.dropdown-toggle  {
    border-radius: 2px !important;
    border-color:rgba(0, 0, 0, 0.07) !important;
  }

  span.selected-tag {
    background-color: white !important;
  }
</style>



// WEBPACK FOOTER //
// client/components/Forms/Elements/SearchAndSelect.vue